import * as ZonesSubscriptionGroupsActions from '../actions/zones-subscription-groups.actions';
import * as ZonesSubscriptionGroupsApiActions from '../actions/zone-subscription-groups-api.actions';
import { ZoneSubscription } from '../../../zones/models/zone-subscription';
import { EntryTypeEnum } from '../../../zones/models/entry-type.enum';
import { ZoneGroup } from 'src/app/zones/models/zone-group';

export interface State {
  error: any;
  zonesSubscriptionGroups: ZoneGroup[];
}

export const initialState: State = {
  error: null,
  zonesSubscriptionGroups: null,
}

export function reducer(
  state = initialState,
  action: ZonesSubscriptionGroupsActions.ZonesSubscriptionGroupsActionsUnion | ZonesSubscriptionGroupsApiActions.ZonesSubscriptionGroupsApiActionsUnion
): State {
  switch (action.type) {
    case ZonesSubscriptionGroupsApiActions.getZoneSubscriptionGroupsFailure.type:
    case ZonesSubscriptionGroupsApiActions.editZoneSubscriptionGroupFailure.type:
    case ZonesSubscriptionGroupsApiActions.createZoneSubscriptionGroupFailure.type:
    case ZonesSubscriptionGroupsApiActions.assignZoneToZoneSubscriptionGroupFailure.type:
    case ZonesSubscriptionGroupsApiActions.unassignZoneToZoneSubscriptionGroupFailure.type: {
      return {
        ...state,
        error: action.error
      };
    }
    case ZonesSubscriptionGroupsApiActions.getZoneSubscriptionGroupsSuccess.type: {
      return {
        ...state,
        zonesSubscriptionGroups: action.data
      };
    }
    case ZonesSubscriptionGroupsApiActions.createZoneSubscriptionGroupSuccess.type: {
      return {
        ...state,
        zonesSubscriptionGroups: [...state.zonesSubscriptionGroups, action.data]
      };
    }
    case ZonesSubscriptionGroupsApiActions.editZoneSubscriptionGroupSuccess.type:
    case ZonesSubscriptionGroupsApiActions.assignZoneToZoneSubscriptionGroupSuccess.type:
    case ZonesSubscriptionGroupsApiActions.unassignZoneToZoneSubscriptionGroupSuccess.type: {
      const newZonesSubscriptions = [...state.zonesSubscriptionGroups];
      const index = newZonesSubscriptions.findIndex(zone => zone.zoneGroupId === action.data.zoneGroupId);
      if (index > -1) {
        newZonesSubscriptions[index] = action.data;
      }
      return {
        ...state,
        zonesSubscriptionGroups: newZonesSubscriptions
      };
    }
    default: {
      return state;
    }
  }
}
export const getError = (state: State) => state.error;
export const getZonesSubscriptionGroups = (state: State) => state.zonesSubscriptionGroups;
export const getZonesSubscriptionGroupById = (state: State, zoneGroupId: number) => state?.zonesSubscriptionGroups?.find(z => z.zoneGroupId === zoneGroupId);